<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <informacoes-basicas
          id="informacoes-basicas-rel"
          :baseDados.sync="baseDados"
          :nomeRelatorio.sync="nomeRelatorio"
          :tipoDadoGeografico.sync="tipoDadoGeografico"
        />
      </v-col>
    </v-row>
    <v-row id="row-campos" :class="esmaecerPagina">
      <v-col cols="12">
        <campos-linhas
          id="campos-linhas"
          ref="refCamposLinhas"
          :campos="camposLinhas"
          :relatorio="relatorio"
          :selecionarTodos="false"
        />
      </v-col>
    </v-row>
    <v-row id="row-filtros" :class="esmaecerPagina">
      <v-col cols="12">
        <campos-filtros
          id="campos-filtros"
          ref="refCamposFiltros"
          :campos="campos"
          :relatorio="relatorio"
          :baseDados="baseDados"
          @loading="loading = $event"
        />
      </v-col>
    </v-row>
    <v-row id="row-btn-save" :class="esmaecerPagina">
      <v-col cols="12">
        <v-btn
          id="btn-save-relatorio"
          color="primary"
          min-width="100"
          style="float: right"
          class="mr-0 mt-n5"
          :loading="loading"
          @click="salvar()"
        >
          Salvar
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import BasesDadosService from '@/services/BasesDadosService';
  import RelatoriosService from '@/services/RelatoriosService';
  import camposFiltrosMixins from '@/mixins/camposFiltrosMixins';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      InformacoesBasicas: () => import('@/components/layers-personalizados/InformacoesBasicas'),
      CamposLinhas: () => import('@/components/relatorios/CamposLinhas'),
      CamposFiltros: () => import('@/components/relatorios/CamposFiltros')
    },
    mixins: [camposFiltrosMixins],

    data: () => ({
      relatorio: {},
      nomeRelatorio: '',
      baseDados: '',
      tipoDadoGeografico: 'PONTO',
      campos: [],
      camposLinhas: [],
      camposValores: [],
      loading: false
    }),

    computed: {
      esmaecerPagina() {
        return this.baseDados == '' ? 'esmaecer esmaecer-aux' : '';
      }
    },

    mounted() {
      if (this.$route.params.id) this.getRelatorio(this.$route.params.id);
    },

    methods: {
      getRelatorio(id) {
        RelatoriosService.getRelatorio(id)
          .then((response) => {
            const rData = response.data.data;
            this.relatorio = rData;
            this.nomeRelatorio = rData.nome;
            this.baseDados = JSON.parse(rData.estrutura_json).tabela;
            this.tipoDadoGeografico = this.relatorio.tipo_dado_geografico;
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar o layer.', '', {
              position: 'topRight'
            })
          );
      },

      baseDeDadosUpdated(tabela) {
        BasesDadosService.getBasesDadosCampos(tabela)
          .then((campos) => {
            const ignorarCampos = this.getIgnorarCamposFiltros();
            this.campos = campos.filter((campo) => !ignorarCampos.includes(campo.column));
            this.camposLinhas = this.campos;
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar campos da base de dados selecionada.', '', { position: 'topRight' });
          });
      },

      salvar() {
        let data = {
          id: this.$route.params.id ? this.$route.params.id : null,
          nome: this.nomeRelatorio,
          base_dados: this.baseDados,
          campos: this.$refs.refCamposLinhas.exportCampos(),
          valores: [],
          filtros: this.$refs.refCamposFiltros.exportCampos(),
          dados_geograficos: true,
          tipo_dado_geografico: this.tipoDadoGeografico
        };

        data = this.validaCamposBeforeSave(data);

        if (data !== 'invalido') {
          RelatoriosService.save(data)
            .then(() => {
              this.$toast.success('Layer salvo com sucesso.', '', {
                position: 'topRight'
              });
              this.$router.replace({
                name: routes.state.appRoutes['LAYERS_PERSONALIZADOS_HISTORICO']
              });
            })
            .catch(() => {
              this.$toast.error('Erro ao salvar o layer.', '', {
                position: 'topRight'
              });
            })
            .finally(() => (this.loading = false));
        }
      },

      validaCamposBeforeSave(data) {
        if (data.filtros == 'invalido') {
          return 'invalido';
        }
        this.loading = true;

        if (data.base_dados == '' || data.nome == '') {
          this.$toast.warning('Preencha as informações básicas.', '', {
            position: 'topRight'
          });
          this.loading = false;
          return 'invalido';
        }

        if (data.campos.length == 0 && data.valores.length == 0) {
          this.$toast.warning('Selecione pelo menos um campo.', '', {
            position: 'topRight'
          });
          this.loading = false;
          return 'invalido';
        }

        return data;
      }
    },

    watch: {
      baseDados(newValue) {
        this.baseDeDadosUpdated(newValue);
      }
    }
  };
</script>

<style scoped>
  .esmaecer {
    pointer-events: none;
    opacity: 0.4;
  }
</style>
